import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "header is-flex is-justify-content-space-between" }
const _hoisted_6 = { class: "title is-4" }
const _hoisted_7 = {
  key: 0,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_8 = {
  key: 1,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_9 = {
  key: 2,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_10 = {
  key: 3,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_11 = {
  key: 4,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_12 = {
  key: 5,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_13 = {
  key: 6,
  class: "subtitle is-6 has-text-grey"
}
const _hoisted_14 = { class: "content-body" }
const _hoisted_15 = {
  key: 0,
  class: "table-container mb-2",
  style: {"max-height":"500px","overflow-y":"auto"}
}
const _hoisted_16 = { class: "table" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = {
  key: 1,
  class: ""
}
const _hoisted_21 = {
  key: 2,
  class: ""
}
const _hoisted_22 = {
  key: 3,
  class: ""
}
const _hoisted_23 = {
  key: 4,
  class: ""
}
const _hoisted_24 = {
  key: 5,
  class: ""
}
const _hoisted_25 = {
  key: 6,
  class: ""
}
const _hoisted_26 = { key: 7 }
const _hoisted_27 = {
  key: 1,
  class: "table-container mb-2",
  style: {"max-height":"500px","overflow-y":"auto"}
}
const _hoisted_28 = { class: "table" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = { class: "is-narrow" }
const _hoisted_31 = {
  key: 2,
  class: "field is-grouped mb-2"
}
const _hoisted_32 = { class: "field is-horizontal is-flex-direction-column-mobile" }
const _hoisted_33 = { class: "field-label is-normal" }
const _hoisted_34 = { class: "label" }
const _hoisted_35 = { class: "field-body" }
const _hoisted_36 = { class: "field" }
const _hoisted_37 = { class: "control" }
const _hoisted_38 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 3,
  class: "field is-horizontal is-flex-direction-column-mobile mb-2"
}
const _hoisted_41 = { class: "field-label is-normal" }
const _hoisted_42 = { class: "label" }
const _hoisted_43 = { class: "field-body" }
const _hoisted_44 = { class: "control" }
const _hoisted_45 = { class: "field-label is-normal" }
const _hoisted_46 = { class: "label" }
const _hoisted_47 = { class: "field-body" }
const _hoisted_48 = { class: "control" }
const _hoisted_49 = { class: "field-body" }
const _hoisted_50 = { class: "control" }
const _hoisted_51 = {
  key: 4,
  class: "table-container mb-2",
  style: {"max-height":"380px","overflow-y":"auto"}
}
const _hoisted_52 = { class: "table" }
const _hoisted_53 = { class: "" }
const _hoisted_54 = { class: "" }
const _hoisted_55 = { class: "" }
const _hoisted_56 = { class: "" }
const _hoisted_57 = { class: "" }
const _hoisted_58 = {
  key: 0,
  class: ""
}
const _hoisted_59 = { class: "" }
const _hoisted_60 = { class: "" }
const _hoisted_61 = { class: "" }
const _hoisted_62 = {
  key: 7,
  class: "table"
}
const _hoisted_63 = { class: "" }
const _hoisted_64 = { class: "" }
const _hoisted_65 = {
  key: 8,
  class: "table"
}
const _hoisted_66 = { class: "" }
const _hoisted_67 = { class: "" }
const _hoisted_68 = { class: "header" }
const _hoisted_69 = {
  key: 0,
  class: "title is-5"
}
const _hoisted_70 = { class: "columns" }
const _hoisted_71 = { class: "column" }
const _hoisted_72 = { class: "field" }
const _hoisted_73 = { class: "label" }
const _hoisted_74 = { class: "control" }
const _hoisted_75 = ["placeholder"]
const _hoisted_76 = { class: "column" }
const _hoisted_77 = { class: "field" }
const _hoisted_78 = { class: "label" }
const _hoisted_79 = { class: "control" }
const _hoisted_80 = ["placeholder"]
const _hoisted_81 = { class: "columns" }
const _hoisted_82 = { class: "column" }
const _hoisted_83 = { class: "field" }
const _hoisted_84 = { class: "label" }
const _hoisted_85 = { class: "control" }
const _hoisted_86 = ["placeholder"]
const _hoisted_87 = { class: "column" }
const _hoisted_88 = { class: "field" }
const _hoisted_89 = { class: "label" }
const _hoisted_90 = { class: "control" }
const _hoisted_91 = ["placeholder"]
const _hoisted_92 = {
  key: 0,
  class: "column"
}
const _hoisted_93 = { class: "field" }
const _hoisted_94 = { class: "label" }
const _hoisted_95 = { class: "control" }
const _hoisted_96 = ["placeholder"]
const _hoisted_97 = {
  key: 1,
  class: "column"
}
const _hoisted_98 = { class: "field" }
const _hoisted_99 = { class: "label" }
const _hoisted_100 = { class: "control" }
const _hoisted_101 = ["placeholder"]
const _hoisted_102 = { class: "field is-grouped is-grouped-right" }
const _hoisted_103 = { class: "control" }
const _hoisted_104 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_105 = { class: "control" }
const _hoisted_106 = { class: "header" }
const _hoisted_107 = { class: "title is-5" }
const _hoisted_108 = { class: "columns" }
const _hoisted_109 = { class: "column" }
const _hoisted_110 = { class: "field" }
const _hoisted_111 = { class: "label" }
const _hoisted_112 = { class: "control" }
const _hoisted_113 = ["placeholder"]
const _hoisted_114 = { class: "field is-grouped is-grouped-right" }
const _hoisted_115 = { class: "control" }
const _hoisted_116 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_117 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_UserTableRow = _resolveComponent("UserTableRow")!
  const _component_SpecialtyTableRow = _resolveComponent("SpecialtyTableRow")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_MngAppointmentRecordTableRow = _resolveComponent("MngAppointmentRecordTableRow")!
  const _component_AppointmentDataForm = _resolveComponent("AppointmentDataForm")!
  const _component_ProductTableRow = _resolveComponent("ProductTableRow")!
  const _component_AppointmentsAccessCodesTableRow = _resolveComponent("AppointmentsAccessCodesTableRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('Management.Mode')), 1),
                (_ctx.getMngMode == 'vets' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_7, _toDisplayString(_ctx.$t('Management.ManageVets')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'managers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_8, _toDisplayString(_ctx.$t('Management.ManageManagers')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'customers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_9, _toDisplayString(_ctx.$t('Management.VisualizeCustomers')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'appointments' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(_ctx.$t('Management.VisualizeAppointments')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'products' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_11, _toDisplayString(_ctx.$t('Management.ManageProducts')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'appointments_access_codes' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_12, _toDisplayString(_ctx.$t('Management.VisualizeAppointmentsAccessCodes')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'specialties' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_13, _toDisplayString(_ctx.$t('Management.VisualizeSpecialties')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                (_ctx.getMngMode == 'vets' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "button is-primary",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.iniCreating && _ctx.iniCreating(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.NewVet')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'managers' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "button is-primary",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.iniCreating && _ctx.iniCreating(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.NewManager')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getMngMode == 'specialties' && !_ctx.creating)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "button is-primary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.iniCreating && _ctx.iniCreating(...args)))
                    }, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('Management.NewSpecialty')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.getMngMode != 'appointments' && _ctx.getMngMode != 'products' &&
                                                  _ctx.getMngMode != 'appointments_access_codes' && _ctx.getMngMode != 'specialties' &&
                                                  !_ctx.creating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("table", _hoisted_16, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('UserData.Id')), 1),
                          (_ctx.getMngMode != 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_17, _toDisplayString(_ctx.$t('UserData.Photo')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('UserData.Name')), 1),
                          _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('UserData.Email')), 1),
                          (_ctx.getMngMode != 'managers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_20, _toDisplayString(_ctx.$t('UserData.Phone')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_21, _toDisplayString(_ctx.$t('CustomerData.CRMVNumber')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_22, _toDisplayString(_ctx.$t('CustomerData.CRMVState')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_23, _toDisplayString(_ctx.$t('CustomerData.Address')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_24, _toDisplayString(_ctx.$t('CustomerData.City')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode == 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_25, _toDisplayString(_ctx.$t('CustomerData.VATNumber')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.getMngMode != 'customers')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_26, _toDisplayString(_ctx.$t('General.Operations')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (user) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: user.user_id
                          }, [
                            _createVNode(_component_UserTableRow, {
                              "user-data": user,
                              parentShowCustomerData: _ctx.showCustomerData,
                              parentShowVetData: _ctx.showVetData
                            }, null, 8, ["user-data", "parentShowCustomerData", "parentShowVetData"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'specialties' && !_ctx.creating)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("table", _hoisted_28, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('SpecialtyData.Id')), 1),
                          _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('SpecialtyData.Name')), 1),
                          _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t('General.Operations')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSpecialties, (specialty) => {
                          return (_openBlock(), _createBlock(_component_SpecialtyTableRow, {
                            key: specialty.specialty_id,
                            "specialty-data": specialty,
                            onRemoveSpecialty: _ctx.removeSpecialtyMeth,
                            onShowSpecialtyData: _ctx.showSpecialtyData,
                            "get-editing-mode": true
                          }, null, 8, ["specialty-data", "onRemoveSpecialty", "onShowSpecialtyData"]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('Management.OfVet')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterVetUserId) = $event)),
                              required: "",
                              class: "select is-fullwidth px-3 is-size-6 mobile-select"
                            }, [
                              _createElementVNode("option", _hoisted_38, _toDisplayString(_ctx.$t('Management.SelectVet')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getUsers, (vet) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: vet.user_id,
                                  value: vet.user_id
                                }, _toDisplayString(vet.name), 9, _hoisted_39))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.filterVetUserId]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('General.From')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_VueDatePicker, {
                          id: "filter_start_date",
                          modelValue: _ctx.filterStartDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterStartDate) = $event)),
                          placeholder: _ctx.$t('General.PleaseSelectDate'),
                          "model-type": "yyyy-MM-dd",
                          "auto-apply": "",
                          "min-date": new Date(1950, 0, 1),
                          "max-date": _ctx.maxDate,
                          "enable-time-picker": false,
                          "prevent-min-max-navigation": "",
                          format: "yyyy-MM-dd"
                        }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('General.To')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_VueDatePicker, {
                          id: "filter_end_date",
                          modelValue: _ctx.filterEndDate,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterEndDate) = $event)),
                          placeholder: _ctx.$t('General.PleaseSelectDate'),
                          "model-type": "yyyy-MM-dd",
                          "auto-apply": "",
                          "min-date": new Date(1950, 0, 1),
                          "max-date": _ctx.maxDate,
                          "enable-time-picker": false,
                          "prevent-min-max-navigation": "",
                          format: "yyyy-MM-dd"
                        }, null, 8, ["modelValue", "placeholder", "min-date", "max-date"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("button", {
                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.ResetFilter')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("table", _hoisted_52, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_53, _toDisplayString(_ctx.$t('AppointmentData.Appointment')), 1),
                          _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t('AppointmentData.Specialty')), 1),
                          _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$t('AppointmentData.Vet')), 1),
                          _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.$t('AppointmentData.Customer')), 1),
                          _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.$t('AppointmentData.Pet')), 1),
                          (_ctx.considerInsurance)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_58, _toDisplayString(_ctx.$t('AppointmentData.Policy')), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.$t('AppointmentData.Price')), 1),
                          _createElementVNode("th", _hoisted_60, _toDisplayString(_ctx.$t('AppointmentData.Status')), 1),
                          _createElementVNode("th", _hoisted_61, _toDisplayString(_ctx.$t('AppointmentData.StatusTime')), 1),
                          _cache[19] || (_cache[19] = _createElementVNode("th", null, null, -1))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAppointments, (appointment) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: appointment.appointment_id
                          }, [
                            _createVNode(_component_MngAppointmentRecordTableRow, { "appointment-data": appointment }, null, 8, ["appointment-data"])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && _ctx.getShowingAppointmentData)
                ? (_openBlock(), _createBlock(_component_AppointmentDataForm, { key: 5 }))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'appointments' && !_ctx.getShowingAppointmentData)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 6,
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.exportAppointmentsToExcel && _ctx.exportAppointmentsToExcel(...args))),
                    class: "button is-primary"
                  }, _toDisplayString(_ctx.$t('Management.ExportToExcel')), 1))
                : _createCommentVNode("", true),
              (_ctx.getMngMode == 'products')
                ? (_openBlock(), _createElementBlock("table", _hoisted_62, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('ProductData.Id')), 1),
                        _createElementVNode("th", _hoisted_63, _toDisplayString(_ctx.$t('ProductData.Designation')), 1),
                        _createElementVNode("th", _hoisted_64, _toDisplayString(_ctx.$t('ProductData.Price')), 1),
                        _cache[20] || (_cache[20] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getProducts, (product) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: product.product_id
                        }, [
                          _createVNode(_component_ProductTableRow, { "product-data": product }, null, 8, ["product-data"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.useAppointsAccessCodes && _ctx.getMngMode == 'appointments_access_codes')
                ? (_openBlock(), _createElementBlock("table", _hoisted_65, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('AppointmentsAccessCodesData.ValidFrom')), 1),
                        _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.$t('AppointmentsAccessCodesData.ValidTo')), 1),
                        _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.$t('AppointmentsAccessCodesData.Code')), 1),
                        _cache[21] || (_cache[21] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAppointmentsAccessCodes, (appointments_access_code) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: appointments_access_code.valid_from
                        }, [
                          _createVNode(_component_AppointmentsAccessCodesTableRow, { "appointments-access-code-data": appointments_access_code }, null, 8, ["appointments-access-code-data"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.creating && _ctx.newItemType == 'user')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 9,
                    onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createUserMeth && _ctx.createUserMeth(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_68, [
                      (_ctx.getMngMode == 'vets')
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_69, _toDisplayString(_ctx.$t('Management.NewVet')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t('UserData.Name')), 1),
                          _createElementVNode("div", _hoisted_74, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 2,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.name) = $event)),
                              class: "input",
                              type: "text",
                              placeholder: _ctx.$t('UserData.NamePlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_75), [
                              [_vModelText, _ctx.newUser.name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('UserData.Email')), 1),
                          _createElementVNode("div", _hoisted_79, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newUser.email) = $event)),
                              class: "input",
                              type: "email",
                              placeholder: _ctx.replaceSpecialCharacters(_ctx.$t('UserData.EmailPlaceholder')),
                              required: ""
                            }, null, 8, _hoisted_80), [
                              [_vModelText, _ctx.newUser.email]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.$t('UserData.Password')), 1),
                          _createElementVNode("div", _hoisted_85, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 6,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newUser.password) = $event)),
                              class: "input",
                              type: "password",
                              placeholder: _ctx.$t('UserData.PasswordPlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_86), [
                              [_vModelText, _ctx.newUser.password]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t('CustomerData.PassConfirmation')), 1),
                          _createElementVNode("div", _hoisted_90, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 6,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newUser.confirmation) = $event)),
                              class: "input",
                              type: "password",
                              placeholder: _ctx.$t('UserData.PassConfirmationPlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_91), [
                              [_vModelText, _ctx.newUser.confirmation]
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.getMngMode != 'managers')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, [
                              _createElementVNode("label", _hoisted_94, _toDisplayString(_ctx.$t('UserData.PhoneNumber')), 1),
                              _createElementVNode("div", _hoisted_95, [
                                _withDirectives(_createElementVNode("input", {
                                  minlength: 6,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.newUser.phone) = $event)),
                                  class: "input",
                                  type: "phone",
                                  placeholder: _ctx.$t('UserData.PhoneNumberPlaceholder'),
                                  required: ""
                                }, null, 8, _hoisted_96), [
                                  [_vModelText, _ctx.newUser.phone]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.getMngMode == 'vets')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                            _createElementVNode("div", _hoisted_98, [
                              _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t('UserData.DiscountPercentage')), 1),
                              _createElementVNode("div", _hoisted_100, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.newUser.discount) = $event)),
                                  class: "input",
                                  type: "number",
                                  min: "0",
                                  max: "100",
                                  step: "5",
                                  placeholder: _ctx.$t('UserData.DiscountPlaceholder'),
                                  required: ""
                                }, null, 8, _hoisted_101), [
                                  [_vModelText, _ctx.newUser.discount]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("p", _hoisted_103, [
                        _createElementVNode("button", _hoisted_104, _toDisplayString(_ctx.$t('General.Save')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_105, [
                        _createElementVNode("a", {
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.toggleCreating && _ctx.toggleCreating(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true),
              (_ctx.creating && _ctx.newItemType == 'specialty')
                ? (_openBlock(), _createElementBlock("form", {
                    key: 10,
                    onSubmit: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createSpecialtyMeth && _ctx.createSpecialtyMeth(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("h5", _hoisted_107, _toDisplayString(_ctx.$t('Management.NewSpecialty')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _createElementVNode("div", _hoisted_109, [
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t('SpecialtyData.Name')), 1),
                          _createElementVNode("div", _hoisted_112, [
                            _withDirectives(_createElementVNode("input", {
                              minlength: 2,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.newSpecialty.name) = $event)),
                              class: "input",
                              type: "text",
                              placeholder: _ctx.$t('SpecialtyData.NamePlaceholder'),
                              required: ""
                            }, null, 8, _hoisted_113), [
                              [_vModelText, _ctx.newSpecialty.name]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_114, [
                      _createElementVNode("p", _hoisted_115, [
                        _createElementVNode("button", _hoisted_116, _toDisplayString(_ctx.$t('General.Save')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_117, [
                        _createElementVNode("a", {
                          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.toggleCreating && _ctx.toggleCreating(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}